import { Navigate } from 'react-router'
import { useQuery } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import API from '@shared/services/src/API'
import { QK, UserRole } from '@shared/utils'

export default function PatientAccessGuard({ redirect = false, patientId, children }) {
  const isAllowed = usePatientAccessible(patientId)

  if (isAllowed === true) return children
  if (isAllowed === false && redirect) return <Navigate replace to="/401" />
  return null
}

export function usePatientAccessible(patientId) {
  const me = useMe()

  const enabledByRole = [UserRole.ClinicalLHC, UserRole.ClinicalQI, UserRole.CBO, UserRole.Provider].includes(me.role)

  const { data } = useQuery({
    queryKey: QK.patients.id(patientId).accessible,
    queryFn: () => API.patients.id(patientId).accessible(),
    enabled: enabledByRole && Boolean(patientId),
    select: (data) => data.accessible,
  })

  return enabledByRole ? data : true
}
